import React from 'react'
import Icon from './Icon'

const Loader = (props) => (
  <div
    className={`ui gp-loader ${props.type} ${props.small ? 'small' : ''} ${
      props.smaller ? 'smaller' : ''
    } ${props.full ? 'full' : ''} ${
      props.withBackground ? 'with-background' : ''
    } ${props.dark ? 'dark' : ''} ${props.icon ? 'icon' : ''} ${
      props.className
    }`}
    style={props.style}
  >
    {props.icon ? <Icon name='loader light' /> : <span />}
    {props.children}
  </div>
)

Loader.defaultProps = {
  type: 'spin',
  style: {},
  className: ''
}

export default Loader
